/**
 * Feature card title sizes
 *
 * @type {string[]}
 */
export const SIZES = ['m', 's', 'xs'];
export const DIRECTIONS = ['column', 'row'];

export default {};
